module.exports = __webpack_public_path__ + "img/cent-thc.ddb9b49a.png";